import { registerModuleUsage } from "../../utils/useModuleAccess"
import React, { useState, useEffect, useRef, useCallback } from "react"

import "react-big-calendar/lib/css/react-big-calendar.css"
import ReactHtmlParser from 'react-html-parser';

import {
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton,
    Tooltip,
    InputBase,
    Popover,
    InputAdornment,
    Divider,
    ListSubheader,
    Alert,
    Button,
    Link,
} from "@mui/material"

import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot
} from "@mui/lab"

import { Calendar, momentLocalizer } from "react-big-calendar"

import userPermissions from "../User/Permissions"

import WhatsAppIcon from "@mui/icons-material/WhatsApp"
import EmailIcon from "@mui/icons-material/Email"
import TelephoneIcon from "@mui/icons-material/Phone"
import EventIcon from "@mui/icons-material/Event"
import PersonIcon from "@mui/icons-material/Person"
import ApartmentIcon from "@mui/icons-material/Apartment"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import CancelIcon from "@mui/icons-material/Cancel"
import CelebrationIcon from "@mui/icons-material/Celebration"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import FacebookIcon from "@mui/icons-material/Facebook"
import TelegramIcon from "@mui/icons-material/Telegram"
import InstagramIcon from "@mui/icons-material/Instagram"
import SmsIcon from "@mui/icons-material/Sms"
import SearchIcon from "@mui/icons-material/Search"
import MessageIcon from "@mui/icons-material/Message"
import BusinessIcon from "@mui/icons-material/Business"
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import HelpIcon from '@mui/icons-material/Help';
import GoogleIcon from '@mui/icons-material/Google';
import WindowIcon from '@mui/icons-material/Window';
import VideocamIcon from '@mui/icons-material/Videocam';
import ReportIcon from '@mui/icons-material/Report';

import Event from "./Event"

import { ScreenContext } from "../Crm"
import ContactProfile from "../Crm/ContactProfile"
import Loading from "../Loading"
import useNotification from "../Notification"
import ContactEnterpriseDialog from "../Dialogs/ContactEnterprise"
import Templates from "../Crm/Templates"
import SendSMS from "../Crm/TabButtons/SendMessage/SendSMS"
import SendEmail from "../Crm/TabButtons/SendMessage/SendEmail"
import EventsNotifications from "../Crm/ContactProfile/events_notifications"
import { useTelephony } from "../../contexts/TelephonyContext"

import moment from "moment"

import dayjs from "dayjs"

import { getSession } from "../../auth"
import api from "../../api"
import { platformIcon } from "../Report/NewDetailedRegister/contact_graph_exception"

import NoteIcon from "@mui/icons-material/Note"
import TaskAltIcon from "@mui/icons-material/TaskAlt"
import GroupsIcon from "@mui/icons-material/Groups"
import SendIcon from "@mui/icons-material/Send"
import { usablePlatforms, channelTranslations } from "./Event"

import "./styles.css"
import { oauthSingleRequest } from "../../utils/oauth_request"
import useInjectComponent from "../../utils/useInjectComponent.js"
import ConfigAgenda from "./ConfigMenu/config_menu.js"
import DistributedCalendar, { distributedCalendar } from "./DistributedCalendar/index.js"

import eventObject, { stateTranslation } from "./event-object.js";
import Shadow from "../../utils/shadowDom.js";

moment.updateLocale("pt-br", {
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    monthsShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    weekdays: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    weekdaysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"]
})

moment.locale("pt-br")
const localizer = momentLocalizer(moment)

const groups = userPermissions()

const calendarTranslations = {
    allDay: "Dia inteiro",
    previous: "Anterior",
    next: "Próximo",
    today: "Hoje",
    month: "Mês",
    week: "Semana",
    day: "Dia",
    agenda: "Agenda",
    date: "Data",
    time: "Hora",
    event: "Evento",
    showMore: (total) => `+ Ver mais (${total})`,
    work_week: "Semana de Trabalho",
    yesterday: "Ontem",
    tomorrow: "Amanhã",
    noEventsInRange: "Nenhum evento neste período."
}

const translations = {
    "TODAY": "Hoje",
    "DELAYED": "Atrasados",
    "SCHEDULED": "Agendados",
    "COMPLETED": "Finalizados",
    "CANCELLED": "Cancelados",
    "NOTE": "Lembretes",
    "ACTIVE": "Atividades",
    "TASK": "Tarefas",
    "MEETING": "Reuniões",
    "BIRTHDAY": "Aniversários",
    "SELF": "Meus eventos"
}

export const eventIcon = {
    "NOTE"     : { name: "Lembrete", component: <NoteIcon sx={{ color: "#333333" }} /> },
    "ACTIVE"   : { name: "Atividade", component: <SendIcon sx={{ color: "#757575" }} /> },
    "TASK"     : { name: "Tarefa", component: <TaskAltIcon sx={{ color: "#333333" }} /> },
    "MEETING"  : { name: "Reunião", component: <GroupsIcon sx={{ color: "#333333" }} /> },
    "BIRTHDAY" : { name: "Aniversário", component: <CelebrationIcon sx={{ color: "#333333" }} /> }
}

export const renderEvent = (event, source) => {
    if (source === "GOOGLE_CALENDAR")
        return <Tooltip title="Google Calendar">
            <GoogleIcon sx={{ color: "#333333" }} />
        </Tooltip>
    if (source === "MICROSOFT_CALENDAR")
        return <Tooltip title="Microsoft Calendar">
            <WindowIcon sx={{ color: "#333333" }} />
        </Tooltip>

    const item = eventIcon[event]
    if (item)
        return <Tooltip title={item.name}>{item.component}</Tooltip>

    return <Tooltip title={event}>
        <BusinessIcon sx={{ color: "#333333" }} />
    </Tooltip>
}

const statusIcon = {
    "COMPLETED" : <CheckCircleIcon sx={{ color: "green" }} />,
    "CANCELLED" : <CancelIcon sx={{ color: "red" }} />,
    "SCHEDULED" : <EventIcon sx={{ color: "#5166a6" }} />
}

export const platforms = (platform, action) => {
    switch (platform) {
        case "whatsapp":
            return (
                <Tooltip title='WhatsApp'>
                    <WhatsAppIcon sx={{ color: "#34af23" }} onClick={action} />
                </Tooltip>
            )
        case "sms":
            return (
                <Tooltip title='SMS'>
                    <SmsIcon sx={{ color: "#757575" }} onClick={action} />
                </Tooltip>
            )
        case "email":
            return (
                <Tooltip title='E-mail'>
                    <EmailIcon sx={{ color: "#757575" }} onClick={action} />
                </Tooltip>
            )
        case "voice":
            return (
                <Tooltip title='Ligação'>
                    <TelephoneIcon sx={{ color: "black" }} onClick={action} />
                </Tooltip>
            )
        default:
            return
    }
}

const Agenda = () => {

    const { callContact } = useTelephony()
    const lastDate = useRef(null)

    const [anchorEl, setAnchorEl] = useState(null)
    const [filterSummary, setFilterSummary] = useState("")

    const handleFilterClick = (event) => setAnchorEl(event.currentTarget)
    const handleFilterClose = () => setAnchorEl(null)

    const filterOpen = Boolean(anchorEl)

    const [reload, setReload] = useState(false)

    const [status, setStatus] = useState("ALL")
    const [event, setEvent] = useState("ALL")
    const [channel, setChannel] = useState("ALL")
    const [dateStatus, setDateStatus] = useState("TODAY")
    const [agent, setAgent] = useState("ALL")
    const [timelineTasks, setTimelineTasks] = useState([])
    const [calendarTasks, setCalendarTasks] = useState([])
    const [calendarNotification, setCalendarNotification] = useState(null)
    const [profile, setProfile] = useState(null)
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [myTeam, setMyTeam] = useState([])
    const [loading, setLoading] = useState(false)
    const [enterprise, setEnterprise] = useState(null)
    const [task, setTask] = useState(null)
    const [whatsAppNotifyData, setWhatsAppNotifyData] = useState({
        show: false,
        templates: [],
        queues: {},
        clients: [],
        selectionIds: [],
        originNumbers: []
    })
    const [smsNotifyData, setSMSNotifyData] = useState({
        show: false,
        queues: [],
        telephone: []
    })
    const [emailNotifyData, setEmailNotifyData] = useState({
        show: false,
        queues: [],
        clients: [],
        canCopy: true,
    })

    const [date, setDate] = useState({
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear()
    })

    const [profileData, setProfileData] = useState({
        originNumbers : [],
        customFields  : [],
        usersEmails   : [],
        ready         : false
    })

    const [events, setEvents] = useState([])
    const [customEvents, setCustomEvents] = useState([])

    const fetchTasks = async (ignore) => {
        let url = `api/users/${getSession().id}/tasks/?supervisor=${groups.isSupervisor}&month=${date.month}&year=${date.year}`
        if (ignore)
            url += ignore.map(i => `&ignore=${i}`).join('')
        const response = await api.get(url)
        if (response.status !== 200)
            throw new Error("Erro ao carregar eventos da agenda Kwik")
        return response.data.filter((item) => item.description !== "INTERNAL-NOTIFICATION")
    }

    const processEvents = (data) => {
        setTimelineTasks(data)
        setCalendarTasks(data)
    }

    const fetchEvents = async (date, force=false) => {
        if (lastDate.current?.month === date.month && lastDate.current?.year === date.year && !force)
            return

        const start = dayjs().year(date.year).month(date.month - 1).startOf("month")
        const end   = dayjs().year(date.year).month(date.month - 1).endOf("month")

        setLoading(true)

        try {
            const distributedCalendarData = await distributedCalendar.lazy_data()
            
            const ignoreKwikCalendars = distributedCalendarData.flatMap(row => row.provider === "KWIK" && row.hide ? row.id : [])
            const googleCalendars = distributedCalendarData.filter(row => row.provider === "GOOGLE_CALENDAR" && !row.hide)
            const microsoftCalendars = distributedCalendarData.filter(row => row.provider === "MICROSOFT_CALENDAR" && !row.hide)

            const externalCalendarRequests = [
                ...(googleCalendars.map(row => ({
                    url      : `?singleEvents=true&orderBy=startTime&timeMin=${start.format()}&timeMax=${end.format()}`,
                    method   : "GET",
                    provider : row.provider.toLowerCase(),
                    email    : row.email,
                    user_id  : row.owner
                }))),
                ...(microsoftCalendars.map(row => ({
                    url      : `calendarView?startDateTime=${start.format()}&endDateTime=${end.format()}`,
                    method   : "GET",
                    provider : row.provider.toLowerCase(),
                    email    : row.email,
                    user_id  : row.owner
                })))
            ]

            const results = await Promise.allSettled([
                fetchTasks(ignoreKwikCalendars),
                ...externalCalendarRequests.map(request => oauthSingleRequest(request))
            ])

            const failedCalendars = []
            const getCalendarName = (index) => {
                if (index === 0)
                    return "Kwik"

                const request = externalCalendarRequests[index - 1]
                const provider = request?.provider === "google_calendar"
                    ? "Google Calendar"
                    : request?.provider === "microsoft_calendar"
                        ? "Microsoft Calendar"
                        : "Agenda externa"

                return request?.email ? `${provider} (${request.email})` : provider
            }

            const registerCalendarFailure = (index) => {
                const calendar = getCalendarName(index)
                if (!failedCalendars.includes(calendar))
                    failedCalendars.push(calendar)
            }

            const notifyCalendarFailures = (partial=true) => {
                if (!failedCalendars.length)
                    return

                const message = failedCalendars.length === 1
                    ? `Não foi possível carregar a agenda ${failedCalendars[0]}.`
                    : `Não foi possível carregar as agendas: ${failedCalendars.join(", ")}.`

                useNotification(
                    partial ? "Atenção!" : "Ops!",
                    partial ? `${message} As demais agendas foram carregadas normalmente.` : message,
                    partial ? "warning" : "danger"
                )
            }

            const successfulResults = results.flatMap((result, index) => {
                if (result.status === "rejected") {
                    console.error("Erro ao carregar agenda", result.reason)
                    registerCalendarFailure(index)
                    return []
                }

                if (!Array.isArray(result.value) && result.value?.status_code >= 400) {
                    console.error("Erro ao carregar agenda externa", result.value)
                    registerCalendarFailure(index)
                    return []
                }

                return [{ value: result.value, index }]
            })

            if (!successfulResults.length && results.length) {
                notifyCalendarFailures(false)
                return
            }

            const loadedCalendars = new Set(successfulResults.map(result => result.index))
            const events = successfulResults.flatMap(({ value, index }) => {
                try {
                    const calendarResults = Array.isArray(value) ? value : [value]

                    return calendarResults.flatMap((result) => {
                        if (!result.event && !result._source) return []
                        switch (result._source){
                            case 'GOOGLE_CALENDAR':
                                return (result.items || []).map(item =>(eventObject({object:item, provider:result._source, source: result._source_email})))
                            case 'MICROSOFT_CALENDAR':
                                return (result.value || []).map(item =>(eventObject({object:item, provider:result._source, source: result._source_email})))
                            default:
                                return eventObject({object:result, provider: "KWIK", source: result.target_username})
                        }
                    })
                } catch (err) {
                    console.error(`Erro ao processar agenda ${getCalendarName(index)}`, err)
                    registerCalendarFailure(index)
                    loadedCalendars.delete(index)
                    return []
                }
            })

            if (!loadedCalendars.size && results.length) {
                notifyCalendarFailures(false)
                return
            }

            notifyCalendarFailures()

            processEvents(events)
            lastDate.current = date
        } catch (err) {
            console.error(err)
            useNotification("Ops!", "Erro ao carregar eventos", "danger")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            const userId = getSession()?.id
            const enterpriseId = getSession().profile.enterprise.id
            const accountcode = getSession().profile.enterprise.accountcode
            const teamRequest = groups.isSupervisor ? api.get(`api/users/${getSession().id}/myteam/`) : {}
            const [
                reqDialogNumbers,
                reqMetaNumbers,
                reqCustomFields,
                reqUsersEmails,
                eventsResponse,
                customEventsResponse,
                calendarNotificationResponse,
                teamResponse,
                _
            ] = await Promise.all([
                api.get(`/api/IS/account/${accountcode}/senders/`),
                api.get(`/api/enterprises/${enterpriseId}/whatsapp/`),
                api.get(`api/enterprises/${enterpriseId}/custom_fields/`),
                api.get(`/api/enterprises/${enterpriseId}/users/get_users_emails/`),
                api.get(`api/message_events/`),
                api.get(`api/enterprises/${enterpriseId}/custom_events/`),
                api.get(`api/enterprises/${enterpriseId}/calendar_notification/`),
                teamRequest,
                fetchEvents(date)
            ])
            setLoading(false)
            setProfileData({
                originNumbers: (reqDialogNumbers.status === 200 && reqMetaNumbers.status === 200) ? [...reqDialogNumbers.data, ...reqMetaNumbers.data].map((item) => item.phone_number) : [],
                customFields: (reqCustomFields.status === 200) ? reqCustomFields.data : [],
                usersEmails: (reqUsersEmails.status === 200) ? reqUsersEmails.data : [],
                ready: true
            })
            setEvents((eventsResponse.status === 200) ? eventsResponse.data : [])
            setCalendarNotification((calendarNotificationResponse.status === 200) ? calendarNotificationResponse.data : [])
            setCustomEvents((customEventsResponse.status === 200) ? customEventsResponse.data : [])

            if (teamResponse.status === 200)
                setMyTeam(teamResponse.data[0].members_data)

        }
        if (!profileData.ready)
            fetchData()
        else
            fetchEvents(date)

        distributedCalendar.reload_calendar = () => {fetchEvents(date, true)}
        return () => {
            //distributedCalendar.lazy_data()
            distributedCalendar.reload_calendar = () => {fetchEvents(date, true)}
        }
    }, [date, profileData.ready])

    useEffect(()=>{
        return () => {
            distributedCalendar.clear_promise()
        }
    }, [])

    const getQueues = async () => {
        if (Object.keys(whatsAppNotifyData.queues).length !== 0)
            return whatsAppNotifyData.queues
        return getSession().profile.queues.reduce((acc, queue) => {
            acc[queue.description] = queue.name
            return acc
        }, {})
    }

    const getClients = async (contact) => [contact]
    const getSelectionIds = async (contact) => [contact.id]

    const getOriginNumbers = async () => {
        if (whatsAppNotifyData.originNumbers.length !== 0)
            return whatsAppNotifyData.originNumbers
        let numbers = []
        const response360Dialog = await api.get(`/api/IS/account/${getSession().profile.enterprise.accountcode}/senders/`, { timeout: 0 })
        if (response360Dialog === 200)
            numbers = response360Dialog.data
        const responseMeta = await api.get(`/api/enterprises/${getSession().profile.enterprise.id}/whatsapp/`)
        if (responseMeta.status === 200)
            responseMeta.data.forEach((each) => numbers.push(each.phone_number))
        return numbers
    }

    const setupWhatsAppNotify = async (contact, setup) => {
        // const templates = await getTemplates()
        const queues = await getQueues()
        const clients = await getClients(contact)
        const selectionIds = await getSelectionIds(contact)
        const originNumbers = await getOriginNumbers()
        setWhatsAppNotifyData((prevState) => ({
            ...prevState,
            show: true,
            templates: [],
            queues: queues,
            clients: clients,
            selectionIds: selectionIds,
            originNumbers: originNumbers,
            setup: setup
        }))
    }

    const setupSMSNotify = async (contact, setup) => {
        const queues = await getQueues()
        setSMSNotifyData((prevState) => ({
            ...prevState,
            show: true,
            queues: queues,
            telephone: [contact.telephone],
            setup: setup
        }))
    }

    const setupEmailNotify = async (contact, setup, canCopy=true) => {
        const queues = await getQueues()
        const clients = await getSelectionIds(contact)
        setEmailNotifyData((prevState) => ({
            ...prevState,
            show: true,
            queues: queues,
            clients: clients,
            setup: setup,
            canCopy: canCopy
        }))
    }

    useEffect(() => {
        const foundAgent = myTeam.find(obj => obj.id === agent)
        const agentName = (foundAgent) ? `${foundAgent.first_name} ${foundAgent.last_name}` : ""
        const filters = [
            dateStatus !== "ALL" && translations[dateStatus],
            status !== "ALL" && translations[status],
            event !== "ALL" ? ((event in translations) ? translations[event] : event) : null,
            channel !== "ALL" && channel.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" "),
            agent !== "ALL" && (translations[agent] || agentName),
        ].filter(Boolean)
        setFilterSummary((filters.length === 0) ? "Todos os eventos do mês" : filters.join(", "))
    }, [dateStatus, status, event, channel, agent])

    const MonthEvent = ({ event }) => {
        const start = event.startDate
        const hours   = start.getHours().toString().padStart(2, "0")
        const minutes = start.getMinutes().toString().padStart(2, "0")
        const time    = `${hours}:${minutes}`

        return (
            <span>
                {time !== "00:00" && (
                    <strong>{time} </strong>
                )}
                {event.title}
            </span>
        )
    }

    const getEventDate = (event) => {
        if (event.startDate) return new Date(event.startDate)
        return new Date(0)
    }

    useInjectComponent(
        ConfigAgenda,
        "rbc-toolbar-label",
        [date, reload, profileData.originNumbers, JSON.stringify(calendarNotification)],
        {
            originNumbers: profileData.originNumbers,
            calendarNotification: calendarNotification,
            setCalendarNotification: setCalendarNotification
        }
    )
    
    return (
        <>
            <Loading loading={loading} />    
            <DistributedCalendar />        
            {task && <EventsNotifications task={task} handleClose={()=>setTask(null)}/>}
            {profile
                ? (
                    <ScreenContext.Provider value={{
                        profile: profile,
                        templates: [],
                        queues: Object.fromEntries(getSession().profile.queues.map(queue => [queue.description, queue.name])),
                        clients: [profile],
                        originNumbers: profileData.originNumbers,
                        customFields: profileData.customFields,
                        enterpriseId: getSession().profile.enterprise.id,
                        setProfile: setProfile,
                        getClients: () => { },
                        usersEmails: profileData.usersEmails
                    }}>
                        <Box className="screen-wrapper">
                            <Box className="outer-Screen profile">
                                <IconButton onClick={() => setProfile(null)}><ArrowBackIcon /></IconButton>
                            </Box>
                            <Box className="table-screen">
                                <ContactProfile />
                            </Box>
                        </Box>
                    </ScreenContext.Provider>
                )
                : null
            }
            <Box className="agenda-container">
                <Box className="agenda-timeline">
                    <Box className="timeline-filters">
                        <InputBase
                            fullWidth
                            value={filterSummary}
                            disabled
                            onClick={handleFilterClick}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton edge="end" size="small">
                                        <SearchIcon fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            }
                            className="timeline-input-filter"
                        />
                        <Popover
                            open={filterOpen}
                            anchorEl={anchorEl}
                            onClose={handleFilterClose}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                        >
                            <Box p={2} display="flex" flexDirection="column" gap={2} minWidth={250}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Data</InputLabel>
                                    <Select
                                        label="Data"
                                        value={dateStatus}
                                        onChange={(event) => setDateStatus(event.target.value)}
                                    >
                                        <MenuItem value="TODAY">Hoje</MenuItem>
                                        <MenuItem value="DELAYED">Atrasados</MenuItem>
                                        <MenuItem value="ALL">Todos</MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        label="Status"
                                        value={status}
                                        onChange={(event) => setStatus(event.target.value)}
                                    >
                                        <MenuItem value="ALL">Todos</MenuItem>
                                        <MenuItem value="SCHEDULED">Agendados</MenuItem>
                                        <MenuItem value="COMPLETED">Finalizados</MenuItem>
                                        <MenuItem value="CANCELLED">Cancelados</MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Evento</InputLabel>
                                    <Select
                                        label="Evento"
                                        value={event}
                                        onChange={(event) => setEvent(event.target.value)}
                                    >
                                        <MenuItem value="ALL">Todos</MenuItem>
                                        <MenuItem key="BIRTHDAY" value="BIRTHDAY">Aniversário</MenuItem>
                                        <MenuItem key="ACTIVE" value="ACTIVE">Atividade</MenuItem>
                                        <Divider />
                                        <ListSubheader>Sistema</ListSubheader>
                                        {events.filter((event) => event.identifier !== "BIRTHDAY").map((event) => (
                                            <MenuItem key={event.identifier} value={event.identifier}>{event.name}</MenuItem>    
                                        ))}
                                        <Divider />
                                        <ListSubheader>Customizados</ListSubheader>
                                        {customEvents.map((event) => (
                                            <MenuItem key={event.identifier} value={event.identifier}>{event.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {groups.isSupervisor &&
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Operador</InputLabel>
                                        <Select
                                            label="Operador"
                                            value={agent}
                                            onChange={(event) => setAgent(event.target.value)}
                                        >
                                            <MenuItem value="ALL">Todos</MenuItem>
                                            <MenuItem value="SELF">Meus eventos</MenuItem>
                                            {myTeam.map((obj) => (
                                                <MenuItem value={obj.id}>{`${obj.first_name} ${obj.last_name}`}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                }
                            </Box>
                        </Popover>
                    </Box>
                    <Timeline position="right" className="timeline">
                        {timelineTasks
                            .filter(task => {
                                const taskDate = dayjs(task.startDate)
                                let dateCondition = true
                                if (dateStatus === "TODAY")
                                    dateCondition = taskDate.isSame(dayjs(), "day")
                                if (dateStatus === "DELAYED")
                                    dateCondition = task.status === "SCHEDULED" && taskDate.isBefore(dayjs())
                                let statusCondition = true
                                if (status !== "ALL")
                                    statusCondition = (task.status === status)
                                        ? true
                                        : (task.event === "BIRTHDAY" && status === "COMPLETED" && taskDate.isBefore(dayjs()) || task.event === "BIRTHDAY" && status === "SCHEDULED" && taskDate.isAfter(dayjs()))
                                let eventConditions = true
                                if (event !== "ALL")
                                    eventConditions = task.event === event
                                let channelConditions = true
                                if (channel !== "ALL")
                                    channelConditions = task.type === channel
                                let agentConditions = true
                                if (agent !== "ALL")
                                    agentConditions = ((agent === "SELF" && task.target === getSession().id) || agent === task.target)
                                return dateCondition && statusCondition && eventConditions && channelConditions && agentConditions
                            })
                            .sort((a, b) => getEventDate(b) - getEventDate(a))
                            .map((item, index) => (
                                <TimelineItem key={index}>
                                    <TimelineSeparator>
                                        <TimelineDot className="timeline-dot">
                                            {renderEvent(item.event, item.calendar)}
                                            <span className="event-mini-icon">{platformIcon(item.type)}</span>
                                        </TimelineDot>
                                        <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent className="timeline-content">
                                        <Typography variant="body1" className="timeline-content-title" onClick={() => { registerModuleUsage("agenda"); setSelectedEvent(item) }}>
                                            {item.title}
                                            {(item.event === "BIRTHDAY")
                                                ? (dayjs(item.startDate).isBefore(dayjs().startOf("day")))
                                                    ? statusIcon["COMPLETED"]
                                                    : statusIcon["SCHEDULED"]
                                                : statusIcon[item.status]
                                            }
                                        </Typography>
                                        <Typography variant="body2">{(item.event === "BIRTHDAY") ? dayjs(item.startDate).format("DD/MM/YYYY") : dayjs(item.startDate).format("DD/MM/YYYY HH:mm")}
                                            {item.active_notifications?.length > 0 &&
                                                <Tooltip title='Ver notificações'>
                                                    <IconButton onClick={() => setTask(item)}>
                                                        <MessageIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                        </Typography>
                                        <Typography variant="body2" className="timeline-description">
                                            <Box className="timeline-contact-target">
                                                {item.target_data && groups.isSupervisor &&
                                                    <Box className="timeline-target-data">
                                                        <SupportAgentIcon sx={{ fontSize: "1rem" }} /> {item.target_data.name}
                                                    </Box>
                                                }
                                                {item.attendees?.length > 0 && (
                                                    <Box className="timeline-attendees-data">
                                                        {item.attendees.slice(0, 4).map((person, index) => (
                                                            <Box key={person.email ?? index } display="flex" alignItems="center" gap={0.5}>
                                                                {(person.status) === "accepted" && <CheckCircleIcon sx={{ fontSize: "1rem" }} color="success" />}
                                                                {(person.status) === "pending"  && <HelpIcon sx={{ fontSize: "1rem" }} color="warning" />}
                                                                {(person.status) === "declined" && <DoNotDisturbOnIcon sx={{ fontSize: "1rem" }} color="error" />}
                                                                {(person.status) === "tentative" && <ReportIcon sx={{ fontSize: "1rem" }} color="warning" />}
                                                                <Box>{person.email ?? person.emailAddress?.address}</Box>
                                                            </Box>
                                                        ))}
                                                        {item.attendees.length > 4 && (
                                                            <Box mt={.25} fontSize=".9rem">
                                                                +{item.attendees.length - 4} participantes
                                                            </Box>
                                                        )}
                                                    </Box>
                                                )}
                                                {item.contact_group &&
                                                    <Box className="timeline-contact-group-data">
                                                        <GroupsIcon sx={{ fontSize: "1rem" }} /> {item.contact_group_data.name}
                                                    </Box>
                                                }
                                                {item.contact_enterprise_data &&
                                                    <Box className="timeline-contact-enterprise-data" onClick={() => setEnterprise(item.contact_enterprise_data)}>
                                                        <ApartmentIcon sx={{ fontSize: "1rem" }} /> {item.contact_enterprise_data.name}
                                                    </Box>
                                                }
                                                {item.contact_data &&
                                                    <>
                                                        <Box className="timeline-contact-data" onClick={() => setProfile(item.contact_data)}>
                                                            <PersonIcon sx={{ fontSize: "1rem" }} /> {item.contact_data.name}
                                                        </Box>
                                                        <Box className="timeline-contact-channels">
                                                            {Object.keys(getSession().profile.enterprise.platforms)
                                                                .filter(key => getSession().profile.enterprise.platforms[key] === true && ["whatsapp", "sms", "email"].includes(key))
                                                                .map((platform) => (
                                                                    <div key={platform}>
                                                                        {platforms(
                                                                            platform,
                                                                            (() => {
                                                                                if (platform === "whatsapp")
                                                                                    return () => setupWhatsAppNotify(item.contact_data)
                                                                                if (platform === "sms")
                                                                                    return () => setupSMSNotify(item.contact_data)
                                                                                if (platform === "email")
                                                                                    return () => setupEmailNotify(item.contact_data)
                                                                                return () => { }
                                                                            })()
                                                                        )}
                                                                    </div>
                                                                ))
                                                            }
                                                            {getSession().profile.enterprise.has_voice &&
                                                                <div key="voice">
                                                                    {platforms("voice", () => callContact(item.contact_data.telephone))}
                                                                </div>
                                                            }
                                                        </Box>
                                                    </>
                                                }
                                            </Box>
                                            <Box sx={{maxHeight: '10rem', overflow: 'auto'}}>
                                                <Shadow>
                                                    {item.parsed_description || item.description}
                                                </Shadow>
                                            </Box>
                                        </Typography>
                                    </TimelineContent>
                                </TimelineItem>
                            ))
                        }
                    </Timeline>
                </Box>
                <Box className="agenda-calendar">
                    <Calendar
                        localizer={localizer}
                        events={calendarTasks.filter((event) => !distributedCalendar.data_dict[event.email]?.hide)}
                        startAccessor="startDate"
                        endAccessor="endDate"
                        defaultView="month"
                        messages={calendarTranslations}
                        onSelectSlot={({ start, end }) => {
                            if (start.getHours() === 0 && start.getMinutes() === 0) {
                                start.setHours(10, 0, 0, 0)
                                end.setDate(end.getDate() - 1)
                                end.setHours(11, 0, 0, 0)
                            }
                            setSelectedEvent({
                                target_date: start,
                                target_enddate: end
                            })
                        }}
                        onSelectEvent={(event) => { registerModuleUsage("agenda"); setSelectedEvent(event) }}
                        selectable
                        onNavigate={(date, view) => {
                            const newYear = dayjs(date).year()
                            const newMonth = dayjs(date).month() + 1
                            if (newYear !== date.year || newMonth !== date.month)
                                setDate({ year: newYear, month: newMonth })
                        }}
                        onRangeChange={()=>{
                            setReload(p=>!p)
                        }}
                        components={{
                            month: {
                                event: MonthEvent
                            }
                        }}
                        eventPropGetter={(event) => {
                            return {
                                style: {
                                    backgroundColor: event.color || "#5166a6",
                                    color: "white",
                                    borderRadius: "4px",
                                    border: "none"
                                }
                            }
                        }}
                    />
                </Box>
            </Box>
            {selectedEvent &&
                <Event
                    open={selectedEvent}
                    title={(selectedEvent.id) ? "Atualizar evento" : (selectedEvent.event === "BIRTHDAY") ? "Aniversário" : "Criar evento"}
                    handleClose={() => setSelectedEvent(null)}
                    timelineTasks={timelineTasks}
                    processEvents={processEvents}
                    // handleSubmit={(data, recurrent) => (selectedEvent.id) ? updateEvent(data, recurrent) : createEvent(data)}
                    isSupervisor={groups.isSupervisor}
                    myTeam={myTeam}
                    selectedEvent={selectedEvent}
                    setProfile={setProfile}
                    setupWhatsAppNotify={setupWhatsAppNotify}
                    setupSMSNotify={setupSMSNotify}
                    setupEmailNotify={setupEmailNotify}
                    setParentCustomEvents={setCustomEvents}
                    // externalAgendas={distributedCalendar.data.reduce((acc, { provider, email }) => {
                    //     if (!acc[provider])
                    //         acc[provider] = []
                    //     acc[provider].push(email)
                    //     return acc
                    // }, {})}
                    calendarNotification={calendarNotification}
                />
            }
            {enterprise &&
                <ContactEnterpriseDialog
                    open={enterprise}
                    handleClose={() => setEnterprise(null)}
                    createEnterprise={() => { }}
                    updateEnterprise={() => { }}
                    selectedEnterprise={enterprise}
                    disabled={true}
                />
            }
            {whatsAppNotifyData.show &&
                <Templates
                    title={whatsAppNotifyData.setup ? "Configurar notificação de whatsapp" : "Enviar whatsapp ao contato"}
                    open={whatsAppNotifyData.show}
                    templates={whatsAppNotifyData.templates}
                    queues={whatsAppNotifyData.queues}
                    clients={whatsAppNotifyData.clients}
                    selectionIds={whatsAppNotifyData.selectionIds}
                    originNumbers={whatsAppNotifyData.originNumbers}
                    handleClose={() => setWhatsAppNotifyData((prevState) => ({ ...prevState, show: false }))}
                    handlePostSuccess={() => { }}
                    positionFixed
                    setup={whatsAppNotifyData.setup}
                />
            }
            {smsNotifyData.show &&
                <SendSMS
                    queues={smsNotifyData.queues}
                    selectedNumberModel={smsNotifyData.telephone}
                    handleClose={() => setSMSNotifyData((prevState) => ({ ...prevState, show: false }))}
                    positionFixed
                    title={smsNotifyData.setup ? "Configurar notificação de sms" : "Enviar SMS ao contato"}
                    setup={smsNotifyData.setup}
                />
            }
            {emailNotifyData.show &&
                <SendEmail
                    title={emailNotifyData.setup ? "Configurar notificação de e-mail" : "Enviar e-mail ao contato"}
                    queues={emailNotifyData.queues}
                    clients={emailNotifyData.clients}
                    handleClose={() => setEmailNotifyData((prevState) => ({ ...prevState, show: false }))}
                    positionFixed
                    setup={emailNotifyData.setup}
                    canCopy={emailNotifyData.canCopy}
                />
            }
        </>
    )
}

export default Agenda
